<template>
  <div>
    <div v-if="this.IsMobile() != null && !this.$store.state.tab.isCollapse" class="drawer-bg" @click="closeMenu" />
    <!-- 首页布局 -->
    <el-container style="height: 100%">
      <!--auto自适应宽度-->
      <el-aside width="auto" v-show="visibleLeftSide">
        <div v-if="this.IsMobile() != null">
          <div :class="aside_class">
            <common-aside ref="lMenu" />
          </div>
        </div>
        <div v-else>
          <common-aside ref="lMenu" />
        </div>
      </el-aside>
      <el-container>
        <el-header style="height:1px;"></el-header>
        <common-header ref="Tabs" v-show="visibleLeftSide" />
        <!-- <common-tag ref="Tabs" /> -->
        <el-main :style="{ height: (this.IsMobile() != null ? screenHeight : screenHeight) }">
          <!-- 路由出口 -->
          <!-- transition組件解決缓存路由更新頁面丟失bug -->
          <div class="main-container">
              <keep-alive :include="cachedViews">
                <router-view></router-view>
              </keep-alive>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
// 引入左侧菜单组件
import commonAside from "@/components/commonAside.vue";
// 引入头部组件
import commonHeader from "@/components/commonHeader.vue";
// 引入选项卡组件
import commonTag from "@/components/commonTag.vue";

export default {
  inject: ['reload'],
  name: "mainComponent",
  data() {
    return {
      screenWidth: "",
      screenHeight: "",
      aside_class: (this.IsMobile() != null ? "sidebar-container" : ""),

      visibleLeftSide: true,      
    };
  },
  components: {
    commonAside,
    commonHeader,
    commonTag,
  },
  computed: {
    cachedViews() {
      return this.$store.state.tab.cachedViews
    },
    key() {
      return this.$route.fullPath;
    },
  },
  methods: {
    // 檢查是否手機微信瀏覽器
    checkWechatBrowser() {
      // if (/(micromessenger)/i.test(navigator.userAgent)) {
      //   //是否电脑微信或者微信开发者工具
      //   if (/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)) {
      //     //pc微信要設置這行, 否則滾動會亂
      //       this.screenHeight = parseInt(document.body.clientHeight - 93) + "px";
      //   } else {
      //     //手机微信
      //     this.screenHeight = parseInt(document.body.clientHeight - 93) + "px";
      //   }
      // } else {
      //   this.screenHeight = parseInt(document.body.clientHeight - 93) + "px";
      // }
      if(this.IsMobile() != null) {
        this.screenHeight = parseInt(document.body.clientHeight - 43) + "px";
      }
      else {
        this.screenHeight = parseInt(document.body.clientHeight - 93) + "px";
      }
      this.screenWidth = parseInt(document.body.clientWidth);
    },
    closeMenu() {
      this.aside_class = "sidebar-container";
      this.$store.state.tab.isCollapse = true;
    }
  },
  mounted() {
    this.checkWechatBrowser();
    // 监听窗口变化
    window.onresize = () => {
      return (() => {
        this.checkWechatBrowser()
      })();
    };
    /* this.time = setInterval(() => {
      if(version!= this.$store.state.tab.current_version){
        this.reload()
      }     
      clearInterval(this.time);   
    }, 5000);  */
  },
  watch: {
    // 监听窗口变化
    screenWidth() {
      this.$store.commit("set_current_width_page", this.screenWidth + "px");
      // 處理瀏覽器切換設備窗口變化
      if (this.IsMobile() === null) {
        document.getElementsByClassName("scroll-container")[0].style.height = "";
        this.$store.state.tab.isCollapse = false;
      }
      else {
        this.closeMenu()
        document.getElementsByClassName("scroll-container")[0].style.height = "34px";
      }
    },
    screenHeight() {
      // 處理全屏變化頁面高度
      // this.screenHeight = parseInt(document.body.clientHeight - 93) + "px";
      // 将当前页面高度存入store中
      this.$store.commit("get_current_height", this.screenHeight);
      // 處理瀏覽器切換設備窗口變化
      if (this.IsMobile() === null) {
        document.getElementsByClassName("scroll-container")[0].style.height = "";
        this.$store.state.tab.isCollapse = false;
      }
      else {
        this.closeMenu()
        document.getElementsByClassName("scroll-container")[0].style.height = "34px";
      }
    },
  },
  updated() {
    this.SetFontSize(this.$store.getters.size);
    if (this.IsMobile() != null) {
      this.$store.state.tab.current_takeColor="96%"
      this.$store.commit("get_current_layout", "total, sizes, jumper");
      this.$store.commit("get_current_width", "96%");
      this.$store.commit("get_current_access_width", "96%");
      this.$store.commit("get_current_footer", "");
      // 瀏覽器切換設備解決滾動條消失bug
      if (document.getElementsByClassName("el-table__fixed-right")[0] != undefined)
        document.getElementsByClassName("el-table__fixed-right")[0].style.right = "0px";
    }
    else {
      this.$store.state.tab.current_takeColor = "37%"
      this.$store.commit("get_current_layout", "total, sizes, prev, pager, next, jumper");
      this.$store.commit("get_current_width", "51%");
      this.$store.commit("get_current_access_width", "30%");
      this.$store.commit("get_current_footer", "footer");
      // 瀏覽器切換設備解決滾動條消失bug
      if (document.getElementsByClassName("el-table__fixed-right")[0] != undefined)
        document.getElementsByClassName("el-table__fixed-right")[0].style.right = "17px";
    }
  },
};
</script>
<style lang="less" scoped>
.el-header {
  padding: 0;
  background-color: #333;
}

.el-main {
  background-color: #f0f2f5;
  padding: 8px;
}

// 默認按鈕16px
/deep/.el-button--small {
  font-size: 16px;
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.sidebar-container {
  transition: width 0.28s;
  height: 100%;
  position: fixed;
  font-size: 0px;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1001;
  overflow: hidden;
}

// 解決移除右邊出現滾動條(屏蔽導致正式版衝突)
/* /deep/.el-scrollbar__wrap {
  overflow: auto;
} */

.main-container {
  height: 100%;
  width:100%
}
</style>
